<template>
  <div>
    <div id="shopCartPopper" :class="$style.popperPosition" />
    <div class="ShopCart__cartPopper" />
    <tippy
      ref="addToCartTippy"
      :animate-fill="false"
      animation="shift-away"
      :arrow="false"
      :distance="11"
      :interactive="true"
      placement="top-end"
      theme="wika light tooltip"
      to="#shopCartPopper"
      trigger="manuel"
      :z-index="10001"
    >
      <template #content>
        <div id="addToCartPopperContent" class="ShopCart__popperContent">
          <div class="columns is-mobile is-multiline">
            <div class="ShopCart__cartItem column is-full">
              <strong class="ShopCart__headline">{{ config.headline }}:</strong>
              <Button class="ShopCart__close" colour="white" is-close @close="closePopper" />
              <div class="columns is-mobile">
                <div class="column is-one-third">
                  <img :alt="item.title" :src="item.thumbnail" />
                </div>
                <div class="ShopCart__priceBox column is-two-thirds">
                  <strong class="ShopCart__title">{{ item.title }}</strong>
                  <div>{{ item.name }}</div>
                  <p class="ShopCart__heading">
                    {{ config.itemNumber }}:
                    {{
                      typeof item !== 'undefined' &&
                      typeof item.id !== 'undefined' &&
                      !item.id.includes('none_')
                        ? item.id
                        : config.noArtNoAvailableText
                    }}
                  </p>
                  <div>
                    {{ config.pricePerItem }}:
                    <IndividualPrice
                      :btype-list="[
                        {
                          btype: item.productType,
                          minimalPrice: item.pricesingle,
                        },
                      ]"
                      :product-type="item.productType"
                      :value="Number(item.pricesingle)"
                    />
                  </div>
                  <div class="ShopCart__labelBox">
                    <div class="ShopCart__label">{{ config.quantity }}: {{ item.quantity }}</div>
                    <div class="ShopCart__label">
                      <IndividualPrice
                        :btype-list="[
                          {
                            btype: item.productType,
                            minimalPrice: item.pricesingle,
                          },
                        ]"
                        :product-type="item.productType"
                        :quantity="item.quantity"
                        :value="Number(item.pricesingle)"
                      />
                    </div>
                  </div>
                  <div class="ShopCart__tax">
                    {{ config.tax }} &amp;
                    <a :href="config.shippingUrl">
                      {{ config.shippingText }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="ShopCart__cartTotal column is-offset-one-third is-two-thirds">
              <Button
                colour="blue"
                :href="config.shopCartUrl"
                :is-link="true"
                :text="config.buttonText"
              />
            </div>
          </div>
        </div>
      </template>
    </tippy>

    <!-- GTM Data Layer - Always in DOM, updates reactively -->
    <div id="gtm-new-item-added" data-gtm-event="item-added" style="display: none">
      <input id="gtm-added-item-id" data-gtm-new="id" type="hidden" :value="props.item.id || ''" />

      <input
        id="gtm-added-item-quantity"
        data-gtm-new="quantity"
        type="hidden"
        :value="props.item.quantity || 0"
      />
      <input
        id="gtm-added-item-price"
        data-gtm-new="pricesingle"
        type="hidden"
        :value="props.item.pricesingle || 0"
      />
      <input
        id="gtm-added-item-type"
        data-gtm-new="productType"
        type="hidden"
        :value="props.item.productType || ''"
      />
      <input
        id="gtm-added-item-source"
        data-gtm-new="source"
        type="hidden"
        :value="props.item.source || 'unknown'"
      />
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue';
import Button from '../Button/Button.vue';
import { ref } from 'vue';
import IndividualPrice from '../IndividualPrice/IndividualPrice.vue';

const props = defineProps({
  config: {
    type: Object,
    default: () => {},
  },
  item: {
    type: Object,
    default: () => {},
  },
  isPopperOpen: {
    type: Boolean,
    default: false,
  },
});

const addToCartTippy = ref(null);

watch(
  () => props.isPopperOpen,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      newValue === true ? openPopper() : closePopper();
    }
  },
);

const openPopper = () => {
  addToCartTippy.value.show();
};

const closePopper = () => {
  addToCartTippy.value.hide();
};
</script>

<style module>
.popperPosition {
  top: 0;
  right: 10px;
  position: fixed;
  width: 0;
  height: 0;
}
</style>
